module.exports = __webpack_public_path__ + "static/img/gsjj1.d787b56.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/gsjj1.png
// module id = J0u0
// module chunks = 0